//Template.js
///////////////////////////////
//React & Material
import React from 'react';

//Plugins
import styled from 'styled-components';

//Bootstrap Imports
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Image from 'react-bootstrap/Image'
import Mockup from '../media/mockup1.svg';
import Mockup2 from '../media/mockup2.svg';
import Mockup3 from '../media/mockup3.svg';
import { useHistory, Link } from "react-router-dom";
import { useMediaQuery } from 'react-responsive'
//////////////////////////////
//Styled components
const SelectedHeightContainer = styled.div`

  display: flex;
  align-items: center;
  
  @media only screen and (min-width: 768px) {
    height:90vh;
  }

  @media only screen and (max-width: 767px) {
    margin:20vh 0px 20vh 20vh;
  }

  @media only screen and (max-width: 767px) and (orientation: portrait) {
   
  }


`
const FullHeightContainer = styled.div`
  height:110vh;

  display: flex;
  align-items: center;
`


const TitleText = styled.h1`
  font-family: Cardo;
  font-style: normal;
  font-weight: normal;
  font-size: 68px;

  @media only screen and (max-width: 767px) {

    font-size: 35px;
  }

  @media only screen and (max-width: 767px) and (orientation: portrait) {
    font-size: 35px;
  }

`
const SubtitleText = styled.div`
  font-family: Cardo;
  font-style: italic;
  font-weight: normal;
  font-size: 36px;
  line-height: 104.9%;
  /* identical to box height, or 38px */
  color: rgba(255, 255, 255, 0.48);

 
  @media only screen and (max-width: 767px) {
    margin-top:10px;
    font-size: 25px;
    padding-left:20px;
    padding-right:20px;
  }

  @media only screen and (max-width: 767px) and (orientation: portrait) {
    font-size: 25px;
    margin-top:10px;
    padding-left:20px;
    padding-right:20px;
  }
`
const SubtitleTextTop = styled.div`
  margin-top:1vh;
  font-family: Cardo;
  font-style: italic;
  font-weight: normal;
  font-size: 36px;
  line-height: 104.9%;
  /* identical to box height, or 38px */
  color: rgba(255, 255, 255, 0.48);
  text-align:left;
  word-wrap: break-word; 
  max-width:30vw;
  
`
const RightAlign = styled(Col)`
  text-align:right;
  margin-right:4vw;
`

const LeftAlign = styled(Col)`
  text-align:left;
  margin-left:4vw;
`

const CenterAlign = styled(Row)`
  display: flex;
  align-items: center;
`
const PlatformText = styled.text`

font-family: Cardo;
font-style: normal;
font-weight: bold;
font-size: 65px;
line-height: 104.9%;
/* or 68px */
margin-right:15px;

color: #36FFC1;

@media only screen and (max-width: 767px) {
  font-size: 35px;
}

@media only screen and (max-width: 767px) and (orientation: portrait) {
  font-size: 35px;
}
`
const SubPlatformText = styled.text`
  font-family: Cardo;
  font-style: normal;
  font-weight: bold;
  font-size: 65px;
  line-height: 104.9%;
  /* or 68px */

  color: rgba(255, 255, 255, 0.2);
  @media only screen and (max-width: 767px) {
    font-size: 35px;
  }
  
  @media only screen and (max-width: 767px) and (orientation: portrait) {
    font-size: 35px;
  }
`

const CustomBox = styled.div`
  position: absolute;
  bottom: ${props => props.bottom};
  right: ${props => props.right};
  left: ${props => props.left};
`
const CustomRow = styled(Row)`
  position:relative;
`
const CustomRowCenter = styled(Row)`
  position:relative;
  justify-content:center;
`
const CustomRowAlignRight = styled(Row)`
  position:relative;
  float:right;
  margin-right:2vw;
`

const CustomImage = styled.img`
  max-width:80%;
`

const CustomLink = styled(Link)`
text-decoration: none;
color: inherit;
text-decoration: inherit;
    &:focus, &:hover, &:visited, &:link, &:active {
        text-decoration: none;
        color:inherit;
    }
    &:hover{
      text-decoration: none;
      color:#36FFC1;
    }
    
`

const MainContainer = styled.div`
  display:flex;
  align-items:center;
  justify-content:center;
  flex-direction:column;
  position:relative;
`
const ImageWrapper = styled(Image)`
    height:350px;
`

const PlatformWrapper = styled.div`

`

const DescriptionWrapper = styled.div`

`

const Spacer = styled.div `
  width: 100vw;
  height: ${props => props.height}px;
`
///////////////////////////
//Component class
/**
 * Displays a template component
 */
function SelectedWork(props) {
  let history = useHistory();



  const Desktop = ({ children }) => {
    const isDesktop = useMediaQuery({ minWidth: 992 })
    return isDesktop ? children : null
  }
  const Tablet = ({ children }) => {
    const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 991 })
    return isTablet ? children : null
  }
  const Mobile = ({ children }) => {
    const isMobile = useMediaQuery({ maxWidth: 767 })
    return isMobile ? children : null
  }
  const Default = ({ children }) => {
    const isNotMobile = useMediaQuery({ minWidth: 768 })
    return isNotMobile ? children : null
  }

  const isMobile = useMediaQuery({ maxWidth: 767 })

  const MobileView = () => {
    return (
      <>

      <MainContainer>
        <ImageWrapper src={Mockup} fluid />
        <PlatformWrapper>
        <CustomBox bottom="24%" right="14%">
          <PlatformText>
          {props.project.platform}
          </PlatformText>
          <SubPlatformText>
          {props.project.platformSub}
          </SubPlatformText>
        </CustomBox>
        </PlatformWrapper>
        <Spacer height="55"/>
        <DescriptionWrapper>
          <CustomLink onClick={() => history.push('/project/oneBank')}>
            <TitleText>
              {props.project.name}
            </TitleText>
          </CustomLink>
          <SubtitleText>
          {props.project.tagline}
            </SubtitleText>
        </DescriptionWrapper>
      </MainContainer>
      </>
    )
  }
  const ImageRight = () => {
    return (
      <React.Fragment>
        <Container>
          <CenterAlign>
            <RightAlign>
              <CustomLink onClick={() => history.push('/project/oneBank')}>
                <TitleText>
                {props.project.name}
            </TitleText>
              </CustomLink>
              <SubtitleText>
              {props.project.tagline}
            </SubtitleText>
            </RightAlign>
            <Col>
              <CustomRow>
                <img src={Mockup} />
                <CustomBox bottom="-5%" right="14%">
                  <PlatformText>
                  {props.project.platform}
                  </PlatformText>
                  <SubPlatformText>
                  {props.project.platformSub}
                  </SubPlatformText>
                </CustomBox>
              </CustomRow>
            </Col>
          </CenterAlign>
        </Container>
      </React.Fragment>
    )
  }

  const ImageLeft = () => {
    return (
      <React.Fragment>
        <Container>
          <CenterAlign>
            <Col>
              <CustomRowAlignRight>
                <img src={Mockup2} />
                <CustomBox bottom="-5%" left="3%">
                  <PlatformText>
                  {props.project.platform}
                </PlatformText>
                  <SubPlatformText>
                  {props.project.platformSub}
                </SubPlatformText>
                </CustomBox>
              </CustomRowAlignRight>
            </Col>
            <LeftAlign>
              <TitleText>
              {props.project.name}
          </TitleText>
              <SubtitleText>
              {props.project.tagline}
          </SubtitleText>
            </LeftAlign>
          </CenterAlign>
        </Container>
      </React.Fragment>
    )
  }

  const ImageTop = () => {

    return (
      <React.Fragment>
        <Container>
          <CustomRowCenter>
            <CustomImage src={Mockup3} />
            <CustomBox bottom="-3%" right="9%">
              <PlatformText>
              {props.project.platform}
                  </PlatformText>
              <SubPlatformText>
              {props.project.platformSub}
                  </SubPlatformText>
            </CustomBox>
          </CustomRowCenter>
          <Row>
            <TitleText>
            {props.project.project}
            </TitleText>
          </Row>
          <Row>
            <SubtitleTextTop>
            {props.project.tagline}
            </SubtitleTextTop>
          </Row>
        </Container>
      </React.Fragment>
    )
  }

  if(isMobile){
    return (
      <>
        <Spacer height="80"/>
        <MobileView/>
        <Spacer height="120"/> 
      </>
    )
  }

  if (props.alignImage === "left") {
    return (
      <SelectedHeightContainer>
        <ImageLeft />
      </SelectedHeightContainer>
    )
  }
  else if (props.alignImage === "right") {
    return (
      <SelectedHeightContainer>
        <ImageRight />
      </SelectedHeightContainer>
    )
  }
  else if (props.alignImage === "top") {
    return (
      <FullHeightContainer>
        <ImageTop />
      </FullHeightContainer>
    )
  }
  else {
    return (
      <SelectedHeightContainer>
        Display prop type
      </SelectedHeightContainer>
    )
  }


}
export default SelectedWork;